import { registerSW } from "virtual:pwa-register";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { queryClient } from "./lib/query-client";
import { routeTree } from "./routeTree.gen";
import "./styles/index.css";

// Theme auf <html> setzen vor React-Mount (kein Flash)
import { brand } from "./theme/themes";

if (brand.id !== "verbotenfrech") {
	document.documentElement.dataset.theme = brand.id;
}

const router = createRouter({
	routeTree,
	context: { queryClient },
	defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<RouterProvider router={router} />
		</QueryClientProvider>
	</StrictMode>,
);

const updateSW = registerSW({
	onNeedRefresh() {
		window.dispatchEvent(new CustomEvent("sw-update-available", { detail: { updateSW } }));
	},
	onOfflineReady() {
		console.log("App ready for offline use");
	},
});
